export const sygnet = [
  "160 160",
  `
  <title>coreui logo</title>
`,
];
